// extracted by mini-css-extract-plugin
module.exports = {"file":"restautantUpload_file__ygDa2","submit":"restautantUpload_submit__1KpLc"};